import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <div className="education-container">
      <div className="education-content-box">
        <h1>Education</h1>
        <div className="education-section">
          <strong>Master of Science in Data Analytics</strong>
          <div>Rochester Institute of Technology, Dubai (RIT Dubai)</div>
        </div>
        <div className="education-section">
          <strong>B.Tech in Information and Communication Technology</strong>
          <div>Adani University Ahmedabad | 2022–2026</div>
          <div>CGPA: 7.81</div>
        </div>
        <div className="education-section">
          <strong>Higher Secondary Certificate (HSC)</strong>
          <div>A-ONE School Ahmedabad | 2022</div>
          <div>Percentage: 65.38%</div>
        </div>
        <div className="education-section">
          <strong>Secondary School Certificate (SSC)</strong>
          <div>A-ONE School Ahmedabad | 2020</div>
          <div>Percentage: 75.16%</div>
        </div>
      </div>
    </div>
  );
};

export default Education;
